import Vue from 'vue'
import App from './App.vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.css'
import router from './router'
import moment from 'moment'
import 'babel-polyfill'
import DatetimePicker from 'vuetify-datetime-picker'
import 'vuetify-datetime-picker/src/stylus/main.styl'
import VueHtmlToPaper from 'vue-html-to-paper'
import excel from 'vue-excel-export'
import VueAnalytics from 'vue-analytics'
// import Titlecase from 'vue-titlecase'

var Titlecase = require('vue-titlecase')

Vue.config.devtools = false

Vue.prototype.$hostname = 'http://importbck.vilsonscfs.com/api/v1'
Vue.prototype.$basename = 'http://import.vilsonscfs.com/'
Vue.config.productionTip = false

Vue.use(VueAnalytics, {
  id: 'UA-151904197-1',
  router
})

const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css'
  ]
}

Vue.use(Vuetify)
Vue.use(DatetimePicker)
Vue.use(VueHtmlToPaper, options)
Vue.use(excel)
Vue.use(Titlecase)

new Vue({
    router,
    render: h => h(App),
}).$mount('#app');

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('YYYY-MM-DD')
  }
});

Vue.filter('formatDateTime', function(value) {
  if (value) {
    return moment(String(value)).format('YYYY-MM-DD HH:mm')
  }
});



// <style lang="stylus">
//     @import '~vuetify/src/stylus/main';
// </style>

